<nav class="navbar navbar-expand-md navbar-light" style="background-color: #e3f2fd;">
  <a (click)="!isCollapsed" href="#" class="navbar-brand"><h4 class="naslov">BEER GARDEN</h4></a>
  <button (click)="isCollapsed=!isCollapsed" type="button" class="navbar-toggler" data-toggle="collapse" data-target="#navbarCollapse">
      <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse linkovi" id="navbarCollapse" [ngbCollapse]="isCollapsed">
      <div class="navbar-nav ml-auto">
          <a class="nav-item nav-link" routerLink="/start">Start</a>
          <a class="nav-item nav-link" routerLink="/proizvodi">Proizvodi</a>
          <a class="nav-item nav-link" routerLink="/kontakt">Kontakt</a>
      </div>
  </div>
</nav>
<router-outlet></router-outlet>
